import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  display: block;\n  width: ', 'px;\n  height: ', 'px;\n  position: relative;\n  cursor: ', ';\n  ', ' svg {\n    display: block;\n    width: 100%;\n    height: 100%;\n    fill: ', ';\n    stroke: ', ';\n  }\n  path {\n    fill: ', ';\n    stroke: ', ';\n  }\n  &:hover svg,\n  &:hover path {\n    fill: ', ';\n  }\n  ', ';\n'], ['\n  display: block;\n  width: ', 'px;\n  height: ', 'px;\n  position: relative;\n  cursor: ', ';\n  ', ' svg {\n    display: block;\n    width: 100%;\n    height: 100%;\n    fill: ', ';\n    stroke: ', ';\n  }\n  path {\n    fill: ', ';\n    stroke: ', ';\n  }\n  &:hover svg,\n  &:hover path {\n    fill: ', ';\n  }\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      cursor: not-allowed;\n      opacity: 0.3;\n    '], ['\n      cursor: not-allowed;\n      opacity: 0.3;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: -', 'px;\n  right: -', 'px;\n'], ['\n  position: absolute;\n  top: -', 'px;\n  right: -', 'px;\n']);

import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { styles } from 'gipsy-misc';
import * as icons from './icons';
import RedDot from '../RedDot';

var propTypes = {
  icon: PropTypes.string.isRequired,
  dot: PropTypes.bool,
  size: PropTypes.number,
  onClick: PropTypes.func,
  className: PropTypes.string,
  fill: PropTypes.string,
  stroke: PropTypes.string,
  hoverFill: PropTypes.string,
  style: PropTypes.object,
  dotSpace: PropTypes.number,
  disabled: PropTypes.bool
};

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon(props) {
    _classCallCheck(this, Icon);

    var _this = _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).call(this, props));

    _this.onClick = function (e) {
      _this.props.onClick && _this.props.onClick(e);
    };

    return _this;
  }

  _createClass(Icon, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var ignores = ['onClick'];
      for (var prop in propTypes) {
        if (ignores.indexOf(prop) !== -1) {
          continue;
        }
        if (this.props[prop] !== nextProps[prop]) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          dotSpace = _props.dotSpace,
          fill = _props.fill,
          hoverFill = _props.hoverFill,
          stroke = _props.stroke,
          size = _props.size,
          disabled = _props.disabled,
          style = _props.style;

      var SvgIcon = icons[this.props.icon];

      return React.createElement(
        Container,
        {
          className: this.props.className,
          fill: fill,
          hoverFill: hoverFill,
          size: size,
          disabled: disabled,
          onClick: this.onClick,
          cursorPointer: this.props.onClick,
          stroke: stroke,
          style: style },
        React.createElement(SvgIcon, null),
        this.props.dot && React.createElement(AbsoluteRedDot, { dotSpace: dotSpace })
      );
    }
  }]);

  return Icon;
}(Component);

Icon.propTypes = propTypes;
Icon.defaultProps = {
  dotSpace: 6,
  fill: styles.colors.darkGrey,
  stroke: 'none',
  size: 20,
  disabled: false,
  style: {}
};


export default Icon;

var Container = styled.div(_templateObject, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.cursorPointer ? 'pointer' : 'inherit';
}, function (props) {
  return props.disabled && css(_templateObject2);
}, function (props) {
  return props.fill;
}, function (props) {
  return props.stroke;
}, function (props) {
  return props.fill ? props.fill : 'inherit';
}, function (props) {
  return props.stroke ? props.stroke : 'inherit';
}, function (props) {
  return props.hoverFill ? props.hoverFill : props.fill;
}, function (props) {
  return props.style;
});

var AbsoluteRedDot = styled(RedDot)(_templateObject3, function (props) {
  return props.dotSpace;
}, function (props) {
  return props.dotSpace;
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/Icon/index.js
// module id = 42
// module chunks = 0